import { render, staticRenderFns } from "./ShipperInvestRecord.vue?vue&type=template&id=2d029e04&scoped=true&"
import script from "./ShipperInvestRecord.vue?vue&type=script&lang=js&"
export * from "./ShipperInvestRecord.vue?vue&type=script&lang=js&"
import style0 from "./ShipperInvestRecord.vue?vue&type=style&index=0&id=2d029e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d029e04",
  null
  
)

export default component.exports